<ng-container *ngIf="(utilities.onboardingSplash$ | async).show">
  <app-welcome-splash [autoDismissMs]="3000" (finish)="onFinishSplash()"></app-welcome-splash>
</ng-container>

<app-header></app-header>
<div class="h-full bg-gray">
  <div class="select-client-table_container">
    <div class="header-row">
      <h3 i18n>Please, select a Client to continue...</h3>
    </div>
    <table mat-table [dataSource]="data" matSort (matSortChange)="sortData($event)" fdtablecustom>
      @for (column of displayedColumns; track $index) {
      <ng-container [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]='true'
          sortActionDescription="Sort by {{ column }}" [ngClass]="column === 'fdClientId' ? 'table-id' : ''">
          {{ FormatColumns[column] }}
        </th>
        <td mat-cell *matCellDef="let emp" [ngClass]="column === 'fdClientId' ? 'table-id' : ''"
          (click)="selectClient(emp['fdClientId'], emp['isPartner'], emp['companyName'], emp['active'], emp['onboardingId'], emp['status'], emp['acquirerOnboardingId'])">
          @if(column === 'status') {
          <span class="status-chip" [ngClass]="getStatusChipClass(emp[column])">
            {{ emp[column] }}
          </span>
          } @else if(column === 'fdClientId' && emp['isPartner']) {
          {{ emp[column] }}
          <span class="partner-chip">Partner</span>
          } @else {
          {{ emp[column] }}
          }
        </td>
      </ng-container>
      } @for (searchColumn of displayedColumnsSearchInput; track $index) {
      <ng-container [matColumnDef]="searchColumn">
        @if(searchColumn === 'searchInput_select'){
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row"></td>
        } @else {
        <th mat-header-cell *matHeaderCellDef>
          <div>
            <input type="text" class="column-search-input bordered-container"
              (keydown.enter)="searchByColumn($event, searchColumn, true)" [placeholder]="
                FormatColumns[searchColumn.replace('searchInput_', '')]
              " />
          </div>
        </th>
        <td mat-cell *matCellDef="let emp" [ngClass]="searchColumn === 'fdClientId' ? 'table-id' : ''"
          (click)="selectClient(emp['fdClientId'], emp['isPartner'],emp['companyName'], emp['active'], emp['onboardingId'], emp['status'], emp['acquirerOnboardingId'])">
          {{ emp[searchColumn] }}
        </td>
        }
      </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"
        [ngClass]="totalData === 0 && columnSearchDetails.columnSearchQueryParams === '' ? 'display-none' : ''"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsSearchInput; sticky: true"
        [ngClass]="totalData === 0 && columnSearchDetails.columnSearchQueryParams === '' ? 'display-none' : 'second-header-row'">
      </tr>
      <tr mat-row *matRowDef="let emprow; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [colSpan]="displayedColumns.length">
          <app-table-no-data [isSelectClientPage]='true' [isLoading]="isLoading"></app-table-no-data>
        </td>
      </tr>
    </table>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <mat-paginator #paginator [ngClass]="totalData > 0 ? '': 'display-none'" [length]="totalData"
      [pageSizeOptions]="pageSizes" FdTablePagination>
    </mat-paginator>
  </div>
</div>